import MainStore from '../stores/MainStore.js';

export const init = () => {
  /*
  fetch(window.__config_reactjs_cart.discount_json_url, {
      method: 'GET',
  })
  .then(response => response.json())
  .then(data => {
  	MainStore.discounts = data;
  	initalItemsDiscountsMap();
    MainStore.changed();
    //console.log(MainStore.discounts);
  })
  .catch(error => {
    //MainStore.checking_out = false;
    //console.error(error);
  });
  */
  MainStore.discounts = window.__discounts;
  initalItemsDiscountsMap();
  MainStore.changed();
  
}


export const get = (item) =>{
  let discount_data = null;
  for( let key in item.options_with_values ){
    let option = item.options_with_values[key];
    //console.log(option);
    let discount_data_new = getByOption(item.product_id,option.value);
    if( discount_data_new!==null ) discount_data = discount_data_new;
  }
  //console.log(discount_data);
  if( discount_data===null ) return {eligible: false};
  let discount = null;
  for( let key in discount_data ){
    let discount_row = discount_data[key];
    //console.log(discount_row);
    if( item.quantity >= discount_row["quantity"] ){
      discount = discount_row;
    }
  }
  //console.log(discount);
  return {
    eligible: true,
    quantity: discount["quantity"],
    rate: discount["rate"],
    price: discount["new_price"],
    un_labeled_rate: getUnLabelRate(item.product_id),
  };
}

const getByOption = (product_id,option) =>{
  let discount = null;
  //console.log(MainStore.discounts);
  
  if( typeof MainStore.items_discounts_map[product_id] === "undefined" ) return null;

  let discounts = MainStore.items_discounts_map[product_id];
  //console.log(discounts);
  //console.log(option);

  for( let key in discounts.discount_option ){
    let discount_row = discounts.discount_option[key];
    //console.log(discount_row);
    if( discount_row.name==="" || discount_row.name.toLowerCase()===option.toLowerCase() ){
      //console.log(discount_row.discount);
      //discount = [...discount_row.discount];
      discount = discount_row.rates;
    }
  }
  
  //console.log(discount);
  return discount;
}

export const initalItemsDiscountsMap = () =>{
	//console.log( MainStore.cart );
	MainStore.items_discounts_map = {};
  if( MainStore.cart===null ) return;
	//console.log(MainStore.cart);
	//console.log(MainStore.discounts);
	for(let key in MainStore.cart.items ){
		let item = MainStore.cart.items[key];

		for( let key_discount in MainStore.discounts ){
			let discount = MainStore.discounts[key_discount];
      //console.log(discount);
			if( item.product_id === parseInt(discount.id) ){
				//if( typeof MainStore.items_discounts_map[item.product_id]==="undefined" ) MainStore.items_discounts_map[item.product_id] = [];
				//MainStore.items_discounts_map[item.product_id].push(discount);
        MainStore.items_discounts_map[item.product_id] = discount;
			}
		}
	}
	//console.log(MainStore.items_discounts_map);
}

export const getUnLabelRate = (product_id) =>{
  if( typeof MainStore.items_discounts_map[product_id] === "undefined" ) return null;
  let discounts = MainStore.items_discounts_map[product_id];

  return discounts.discount_un_labeled_rate??0;
}